(function () {
    'use strict';

    angular.module('app').factory('whatsNewSharedUtils', WhatsNewSharedUtilsFactory);

    WhatsNewSharedUtilsFactory.$inject = [];
    function WhatsNewSharedUtilsFactory() {
        return {
            extractCoverImages,
        };

        function getImageSourcesFromFigure(figure) {
            if (!figure) {
                return [];
            }

            return Array.from(figure.getElementsByTagName("img"), img => img.src);
        }

        function getFirstFigure(html) {
            const doc = new DOMParser().parseFromString(html, "text/html");

            const figure = doc.body.querySelector("figure");
            if (!figure) return null;

            const walker = doc.createTreeWalker(
                doc.body,
                NodeFilter.SHOW_TEXT,
                {
                    acceptNode(node) {
                        const parent = node.parentElement;

                        if (parent?.closest("script, style")) {
                            return NodeFilter.FILTER_REJECT;
                        }

                        return NodeFilter.FILTER_ACCEPT;
                    }
                }
            );

            let node;
            while ((node = walker.nextNode())) {
                if (node.compareDocumentPosition(figure) & Node.DOCUMENT_POSITION_FOLLOWING) {
                    if (node.textContent.trim()) {
                        return null;
                    }
                }
            }

            return figure;
        }

        function extractCoverImages(html) {
            let figure = null, images = [];

            ({ figure, html } = extractFirstFigure(html));

            while (figure) {
                images = [...images, ...getImageSourcesFromFigure(figure)];

                ({ figure, html } = extractFirstFigure(html));
            }

            return { html, images };
        }

        function extractFirstFigure(html) {
            const figure = getFirstFigure(html);

            if (!figure) {
                return { figure: null, html };
            }

            const extractedFigure = figure.cloneNode(true);
            const body = figure.ownerDocument.body;

            // Remove figure and empty wrapper(s)
            removeAndPrune(figure);

            return {
                figure: extractedFigure,
                html: body.innerHTML
            };
        }

        function removeAndPrune(element) {
            let parent = element.parentElement;

            element.remove();

            while (parent && parent.children.length === 0) {
                const nextParent = parent.parentElement;
                parent.remove();
                parent = nextParent;
            }
        }
    }
})();